// Converted to lazy loading
const discountCodesIndex = () => import('@/pages/discountCodes/index.vue')
const discountCodesForm = () => import('@/pages/discountCodes/form.vue')
const discountCodesShow = () => import('@/pages/discountCodes/show.vue')

const routes = [
  //Discount Codes
  {
    path: 'discountCodes',
    name: 'discountCodes',
    component: discountCodesIndex
  },
  {
    path: 'discountCodes/create',
    name: 'discountCodesCreate',
    component: discountCodesForm
  },
  {
    path: 'discountCodes/:id/edit',
    name: 'discountCodesEdit',
    component: discountCodesForm
  },
  {
    path: 'discountCodes/:id',
    name: 'discountCodesShow',
    component: discountCodesShow
  }
]

export default routes
